import React from 'react';
import { X } from 'lucide-react';

interface CloseProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Close: React.FC<CloseProps> = ({ width = 24, height = 24, className, style }) => (
  <X width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default Close;
